// import ActiveServices from '../components/activeServices/ActiveSevices';
import PortfolioServices from '../components/activeServices/PortfolioServices';

const Services: React.FC = () => {
  return (
    <div>
      {/* <ActiveServices /> */}
      <PortfolioServices />
    </div>
  );
};

export default Services;
